import { createAction } from '../../../utils/redux/createAction';

const actionsScope = 'patient-portal/lab-result-history-modal';

export const LAB_RESULT_HISTORY_MODAL = {
  OPEN: `${actionsScope}/open`,
  CLOSE: `${actionsScope}/close`,
};

export const labResultHistoryModalActions = {
  open: createAction(LAB_RESULT_HISTORY_MODAL.OPEN),
  close: createAction(LAB_RESULT_HISTORY_MODAL.CLOSE),
};

const initialState = {
  list: [],
  name: '',
  opened: false,
  componentCode: '',
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case LAB_RESULT_HISTORY_MODAL.OPEN: {
      const { componentCode, name } = payload;

      return {
        ...state,
        name,
        opened: true,
        componentCode,
      };
    }

    case LAB_RESULT_HISTORY_MODAL.CLOSE: {
      return { ...initialState };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/healthboard/patientPortal/lab-result-history-modal.js